import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EnhancedTable from '../Common/Table/EnhancedTable';
import EnhancedGrid from '../Common/Grid/EnhancedGrid';
import Icon from '@projeccions-pdc/react-icon';
import LibraryFile from './LibraryFileGridItem';
import GroupSelector from '../Common/GroupSelector/GroupSelector';
import LocalizedStrings from './localization.js';

class LibraryResults extends Component {
    render() {
        let actions, columns;
        if (!this.props.isPicker) {
            actions = [
                {
                    action: 'tag',
                    icon: 'fa-tags',
                    onAction: this.props.tagMultipleFiles,
                },
                {
                    action: 'shareable',
                    icon: 'fa-check-circle',
                    onAction: this.props.makeShareableMultipleFiles,
                },
                {
                    action: 'delete',
                    icon: 'md-delete',
                    onAction: this.props.deleteSelected,
                },
            ];
            columns = [
                { name: LocalizedStrings.name, id: 'filename', isSortable: true, numeric: false, disablePadding: true },
                { name: LocalizedStrings.use, id: 'inUse', isSortable: false, numeric: false, disablePadding: true, isBoolean: true },
                {
                    name: LocalizedStrings.shareable,
                    id: 'shareable',
                    isSortable: false,
                    numeric: false,
                    disablePadding: true,
                    isBoolean: true,
                },
                { name: LocalizedStrings.date, id: 'dateCreated', isSortable: true, numeric: false, disablePadding: false, isDate: true },
                {
                    name: LocalizedStrings.uploadedBy,
                    id: 'userSub',
                    isSortable: true,
                    numeric: false,
                    disablePadding: false,
                    render: (element) => {
                        return element.userSub && this.props.usersData && this.props.usersData[element.userSub]
                            ? this.props.usersData[element.userSub].name
                            : '';
                    },
                    export: (element) => {
                        return element.userSub && this.props.usersData && this.props.usersData[element.userSub]
                            ? this.props.usersData[element.userSub].name
                            : '';
                    },
                },
                {
                    name: LocalizedStrings.userGroup,
                    id: 'groupId',
                    isSortable: true,
                    numeric: false,
                    disablePadding: false,
                    render: (element) => {
                        return (
                            <GroupSelector
                                disabled={true}
                                onGroupSelected={() => {}}
                                selectedGroup={element ? element.groupId : undefined}
                                removeGroup={() => {}}
                            />
                        );
                    },
                    export: (element) => {
                        return element.groupId ? element.groupId : 'Avilable for everyone';
                    },
                },
                { name: LocalizedStrings.menu, id: 'menu', isSortable: false, numeric: false, disablePadding: true, isBoolean: true },
                {
                    name: LocalizedStrings.preview,
                    id: 'url',
                    isSortable: false,
                    numeric: false,
                    disablePadding: true,
                    render: (element) => {
                        return (
                            <a target="_blank" rel="noopener noreferrer" href={element.url}>
                                <Icon name="fa-eye" />
                            </a>
                        );
                    },
                },
            ];
        } else {
            actions = [
                {
                    action: 'pick files',
                    onAction: this.props.pickFiles,
                },
            ];
            columns = [
                { name: LocalizedStrings.name, id: 'filename', isSortable: true, numeric: false, disablePadding: true },
                { name: LocalizedStrings.use, id: 'inUse', isSortable: false, numeric: false, disablePadding: false, isBoolean: true },
                { name: LocalizedStrings.date, id: 'dateCreated', isSortable: true, numeric: false, disablePadding: false, isDate: true },
                {
                    name: LocalizedStrings.userGroup,
                    id: 'groupId',
                    isSortable: true,
                    numeric: false,
                    disablePadding: false,
                    render: (element) => {
                        return (
                            <GroupSelector
                                disabled={true}
                                onGroupSelected={() => {}}
                                selectedGroup={element ? element.groupId : undefined}
                                removeGroup={() => {}}
                            />
                        );
                    },
                    export: (element) => {
                        return element.groupId ? element.groupId : 'Avilable for everyone';
                    },
                },
                {
                    name: LocalizedStrings.preview,
                    id: 'url',
                    isSortable: false,
                    numeric: false,
                    disablePadding: true,
                    render: (element) => {
                        return (
                            <a target="_blank" rel="noopener noreferrer" href={element.url}>
                                <Icon name="fa-eye" />
                            </a>
                        );
                    },
                },
            ];
        }

        if (this.props.isGrid === true) {
            return (
                <EnhancedGrid
                    gridTitle={''}
                    rowId={'fileId'}
                    multipleChoice={this.props.multipleChoice}
                    columnData={columns}
                    data={this.props.tableData}
                    loadMore={this.props.partialData ? this.props.loadMore : undefined}
                    actions={actions}
                    GridItemComponent={(props) => {
                        // console.log(
                        //     props.resource.userSub,
                        //     this.props.usersData[props.resource.userSub],
                        //     props.usersData,
                        //     this.props.usersData
                        // );
                        return (
                            <LibraryFile
                                {...props}
                                src={props.resource.fileType === 'image' ? props.resource.url : undefined}
                                uploadedBy={
                                    props.resource.userSub && this.props.usersData[props.resource.userSub]
                                        ? this.props.usersData[props.resource.userSub].name
                                        : ''
                                }
                            />
                        );
                    }}
                    onItemClick={!this.props.isPicker ? this.props.handleEditItem : undefined}
                    gridProps={{ cellHeight: 250, cols: 6, spacing: 10 }}
                />
            );
        } else {
            return (
                <EnhancedTable
                    tableTitle={''}
                    multipleChoice={this.props.multipleChoice}
                    showSelectors={true}
                    rowId={'fileId'}
                    columnData={columns}
                    data={this.props.tableData}
                    loadMore={this.props.partialData ? this.props.loadMore : undefined}
                    onItemClick={!this.props.isPicker ? this.props.handleEditItem : undefined}
                    actions={actions}
                />
            );
        }
    }
}
LibraryResults.propTypes = {
    multipleChoice: PropTypes.bool,
    isGrid: PropTypes.bool.isRequired,
    tableData: PropTypes.array.isRequired,
    usersData: PropTypes.object.isRequired,
    loadMore: PropTypes.func.isRequired,
    tagMultipleFiles: PropTypes.func.isRequired,
    deleteSelected: PropTypes.func.isRequired,
    makeShareableMultipleFiles: PropTypes.func.isRequired,
    pickFiles: PropTypes.func.isRequired,
    partialData: PropTypes.any,
    isPicker: PropTypes.bool.isRequired,
    handleEditItem: PropTypes.func.isRequired,
};

export default LibraryResults;
